/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const initCurrentNav = () => $('nav.header a.link-item').each(function(i, link) {
  const href = $(link).prop("href");
  const currentPath = window.location.pathname;

  if (endsWith(href, currentPath)) {
    return $(link).addClass("current");
  }
});


/*
$(function() {
  if ($('nav.header .links').length) {
    return initCurrentNav();
  }
});
*/

function initCurrentNavOnLoad() {
  if ($('nav.header .links').length) {
    initCurrentNav();
  }
}

$(initCurrentNavOnLoad);
document.addEventListener('turbo:load', initCurrentNavOnLoad);
